import React, {FC} from 'react';
import {useDispatch} from 'react-redux';

import {EMetaActionType} from 'entities/metadata';
import {actionForRequests} from 'modules/data/data-actions';
import {selectTableSelectedRowKeys} from 'modules/data/data-selectors';
import {ECommonMessages} from 'shared/constants/messages';
import {ERequestType} from 'shared/types/requests';
import {showMessage} from 'shared/utils';
import {useAppSelector} from 'store/config/hooks';

import {ActionButton} from '../action-button';
import {ITableActionProps} from '../table-action-types';

export const ButtonActionRequests: FC<ITableActionProps> = ({
    meta,
    wrapper,
    entityName,
    ...props
}: ITableActionProps) => {
    const dispatch = useDispatch();
    const selectedRowKeys = useAppSelector(selectTableSelectedRowKeys(entityName)) || [];

    const handleClick = async () => {
        const {requestType, referenceUrl, actionType} = meta;
        const idsList: string[] = selectedRowKeys.map((row: number | string) => String(row));
        if (referenceUrl) {
            if (actionType === EMetaActionType.BUTTON_MARK_AS_READ) {
                if (selectedRowKeys?.length === 0) {
                    showMessage({message: ECommonMessages.SELECT_QUERY, isError: true});
                }
                dispatch(
                    actionForRequests(entityName, requestType || ERequestType.POST, referenceUrl, idsList),
                );
            }
            if (meta?.actionType === EMetaActionType.BUTTON_MARK_ALL_AS_READ) {
                dispatch(
                    actionForRequests(entityName, requestType || ERequestType.POST, referenceUrl),
                );
            }
        }
    };
    const Component = wrapper || ActionButton;
    return (
        <Component
            {...props}
            onClick={handleClick}
            actionIcon={meta.actionIcon}
            disabled={!(selectedRowKeys.length || meta?.actionType === EMetaActionType.BUTTON_MARK_ALL_AS_READ)}
        >
            {meta.actionTitle}
        </Component>
    );
};
